import styled from 'styled-components'

interface ChooseHorseItemStyledProps {
  currentEnergy: number
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const handleTheme = (theme: any, currentEnergy: any) => {
  if (currentEnergy && currentEnergy <= 27) {
    return theme.color.orange
  }
  if (currentEnergy && currentEnergy <= 47) {
    return theme.color.yellow
  }
  if (currentEnergy && currentEnergy <= 73) {
    return theme.color.blue
  }
  if (currentEnergy && currentEnergy <= 100) {
    return theme.color.white
  }
}

const ChooseHorseItemStyled = styled.div<ChooseHorseItemStyledProps>`
  clip-path: polygon(0 0, 100% 0, 100% 100%, 20px 100%, 0% calc(100% - 20px));
  padding: 1px;

  &:hover {
    background: ${({ theme }) => theme.color.primary};
  }

  .choose-horse-item {
    background-color: ${({ theme }) => theme.color.darkBlue};
    clip-path: polygon(0 0, 100% 0, 100% 100%, 20px 100%, 0% calc(100% - 20px));
    padding: 16px;

    .left-container {
      .avatar-container {
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
        margin-bottom: 10px;
        .avata__img {
          width: 82px;
        }

        .avatar {
          width: 82px;
          aspect-ratio: 82/64;
          object-fit: contain;
          object-position: center;
        }
      }

      .energy-container {
        gap: 4px;

        .energy-icon {
          width: 20px;
          aspect-ratio: 1;
        }

        .energy-bar {
          width: 64px;
          height: 4px;
          background-color: rgba(255, 255, 255, 0.3);

          &:after {
            content: '';
            display: block;
            position: absolute;
            top: 0;
            left: 0;
            width: ${({ currentEnergy }) => currentEnergy}%;
            height: 100%;
            background-color: ${({ theme, currentEnergy }) => handleTheme(theme, currentEnergy)};
          }
        }
      }
      .energy-text {
        font-size: 14px;
      }
      .link-container {
        .link {
          font-size: 16px;
          line-height: 20px;
        }
      }
    }

    .mid-container {
      .horse-container {
        .ct_gender {
          margin-right: -5px;
        }

        .name {
          font-size: 18px;
          line-height: 20px;
          width: 125px;
          word-break: break-all;
        }

        div {
          div {
            img {
              margin-left: 0px;
            }
          }
        }

        .region {
          width: 20px;
          height: 20px;
          margin-left: 8px;
        }

        .bloodline-gender {
          font-size: 16px;
          line-height: 16px;
          margin-bottom: 5px;
        }

        .class-type {
          /* margin-bottom: 6px; */
          display: flex;
          align-items: center;
        }

        .extra-info {
          gap: 8px;

          .title {
            min-width: 80px;
            font-size: 14px;
            line-height: 14px;
          }

          .content {
            font-size: 16px;
            line-height: 19px;
          }
        }
        .used-doping{
          width: 40px;
          /* margin-top: -10px; */
        }

        .img_new_record {
          width: 30px;
          height: auto;
          margin-left: 10px;
        }

        .align-items-start {
          align-items: start !important;
        }
      }
    }

    .right-container {
      .stat-container-border {
        clip-path: polygon(calc(100% - 10px) 0, 100% 10px, 100% 100%, 0 100%, 0 0);
        background-color: ${({ theme }) => theme.color.yellow};
        padding: 1px;

        .stat-container {
          clip-path: polygon(calc(100% - 10px) 0, 100% 10px, 100% 100%, 0 100%, 0 0);
          background-color: ${({ theme }) => theme.color.darkBlue};
          padding: 12px;
          width: 200px;
          row-gap: 12px;

          .stat-item {
            gap: 5px;

            .stat-title {
              font-size: 12px;
              line-height: 14px;
              min-width: 45px;
            }

            .stat-content {
              font-size: 16px;
              line-height: 19px;
            }
          }
          .ability-wrap-content {
            display : flex;
            flex-direction: column;
          }
        }
      }
    }
  }
  .box__bloodline {
    display: flex;
    align-items: center;
    margin: 5px 0;

    .image_bloodline {
      display: flex;
      align-items: center;
      height: 35px;
      margin-right: 15px;
    }

    .image_run_type {
      display: flex;
      align-items: center;
      height: 20px;
      margin-right: 15px;
    }

    .image_charitic {
      display: flex;
      align-items: center;
      height: 30px;
      margin-right: 15px;
    }
  }
  .img__ability {
    width: 25px;
    height: 25px;
    margin: 2px 0;
    cursor: pointer;
  }
`

export default ChooseHorseItemStyled
